import { DeviceFrameSpec } from "components/elements/DeviceFrame"
import iPhone16ProBlackTitaniumFrame from "assets/deviceFrames/iphone-16-pro-black-titanium/frame.png"
import iPadPro11M4PortraitFrame from "assets/deviceFrames/ipad-pro-11-m4-space-black-portrait/frame.png"
import iPadPro11M4LandscapeFrame from "assets/deviceFrames/ipad-pro-11-m4-space-black-landscape/frame.png"

export const IPHONE_16_PRO_BLACK_TITANIUM: DeviceFrameSpec = {
  frameSrc: iPhone16ProBlackTitaniumFrame,
  screen: {
    x: 102,
    y: 100,
    width: 1206,
    height: 2622,
  },
  frameSize: {
    width: 1406,
    height: 2822,
  },
  screenRadius: 18,
}

export const IPAD_PRO_11_M4_PORTRAIT: DeviceFrameSpec = {
  frameSrc: iPadPro11M4PortraitFrame,
  screen: {
    x: 99,
    y: 100,
    width: 1668,
    height: 2420,
  },
  frameSize: {
    width: 1868,
    height: 2620,
  },
}

export const IPAD_PRO_11_M4_LANDSCAPE: DeviceFrameSpec = {
  frameSrc: iPadPro11M4LandscapeFrame,
  screen: {
    x: 100,
    y: 100,
    width: 2420,
    height: 1668,
  },
  frameSize: {
    width: 2620,
    height: 1868,
  },
}

// Preview widths are derived from a 460px iPad long-edge target, scaled to
// match real device proportions and screen width ratios. Values are pre-computed.
const IPAD_PREVIEW_LONG_EDGE_PX = 460

export const IPHONE_PREVIEW_WIDTH_PX = 165
export const IPAD_PORTRAIT_PREVIEW_WIDTH_PX = 328
export const IPAD_LANDSCAPE_PREVIEW_WIDTH_PX = IPAD_PREVIEW_LONG_EDGE_PX

export const IPHONE_PREVIEW_WIDTH = `${IPHONE_PREVIEW_WIDTH_PX}px`
export const IPAD_PORTRAIT_PREVIEW_WIDTH = `${IPAD_PORTRAIT_PREVIEW_WIDTH_PX}px`
export const IPAD_PORTRAIT_PREVIEW_HEIGHT = `${IPAD_PREVIEW_LONG_EDGE_PX}px`
export const IPAD_LANDSCAPE_PREVIEW_WIDTH = `${IPAD_LANDSCAPE_PREVIEW_WIDTH_PX}px`
